<template>
    <article class="news-card">
        <div class="thumb">
            <a href="/blog/id/slug">
                <picture><img alt=" " src="/static/images/news.jpg" /></picture>
            </a>
            <a class="tag">Poupança</a>
        </div>
        <div class="content">
            <h4>
                <a href="/blog/id/slug">Gasóleo ou Gasolina: Qual a compra mais inteligente?</a>
            </h4>
            <div class="meta">11 Outubro 2020</div>
        </div>
    </article>
</template>

<script>
export default {};
</script>